<template>
    <div>
        <VippsPayment v-if="selectedVipps"></VippsPayment>
        <VippsPaymentProgress></VippsPaymentProgress>
        <NettbankPayment v-show="selectedNettbank"></NettbankPayment>
        <div class="row" v-show="errorMessage.length > 0">
            <div class="col-12">
                <div class="alert alert-danger text-center">
                    <strong>{{ errorMessage }}</strong>
                </div>
            </div>
        </div>
        <div class="row" v-show="successMessage.length > 0">
            <div class="col-12">
                <div class="alert alert-primary text-center">
                    <strong>{{ successMessage }}</strong>
                </div>
            </div>
        </div>
        <div v-show="displayPaymentMethods">
            <hr class="my-4" v-show="paymentMethodIsSet && multiplePaymentsEnabled">
            <div class="row my-4" v-show="!isLoading && multiplePaymentsEnabled">
                <div class="col-12">
                    <h1 class="text-3xl ps-2">
                        {{ $t('Betalingsalternativer') }}
                    </h1>
                </div>
            </div>
            <div class="text-center col-12 mt-5" v-show="isLoading">
                <span class="spinner-border" role="status"></span>
            </div>
            <div class="row" v-show="!isLoading && multiplePaymentsEnabled">
                <div class="col-lg-6 mb-3" v-show="vippsEnabled">
                    <div class="card hover-shadow payment payment-vipps cursor-pointer h-100" @click="selectPaymentMethod('vipps')" :class="{ 'selected': selectedVipps, 'fade-out': shouldFadeOut }">
                        <div class="card-body">
                            <h4 class="fw-bold">{{ $t('Hurtigbetaling med Vipps') }}</h4>
                            <p>{{ $t('Betaling registreres hos skolen umiddelbart') }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-3 align-self-stretch" v-show="nettbankEnabled">
                    <div class="card hover-shadow cursor-pointer payment payment-nettbank h-100" @click="selectPaymentMethod('nettbank')" :class="{ 'selected': selectedNettbank, 'fade-out': shouldFadeOut }">
                        <div class="card-body">
                            <h4 class="fw-bold">{{ $t('Betal med nettbank') }}</h4>
                            <p>{{ $t('Betaling registreres hos skolen i løpet av 1-3 virkedager') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    h2 {
        word-break: break-word;
        hyphens: auto;
    }
</style>
<script setup>
import { ref, computed, onMounted } from 'vue'
import Store from '../../state/paymentStore.js'
import VippsPayment from './VippsPayment'
import NettbankPayment from './NettbankPayment'
import VippsPaymentProgress from './VippsPaymentProgress'

const props = defineProps(['accountorderhistoryid', 'isstrictinvoicing', 'payinvoiceablelines', 'preselectedpaymentmethod', 'depositamount'])

const accountOrderHistoryId = ref(props.accountorderhistoryid)
const isStrictInvoicing = ref(props.isstrictinvoicing)
const payInvoiceableLines = ref(props.payinvoiceablelines)

onMounted(() => {
    if (accountOrderHistoryId.value) {
        Store.setAccountOrderHistoryId(accountOrderHistoryId.value)
    }
    if (payInvoiceableLines.value) {
        Store.setPayInvoiceableLines(true)
    }
    if (isStrictInvoicing.value) {
        Store.setIsStrictInvoicing(true)
    }
    if (props.depositamount) {
        Store.setSum(props.depositamount)
    }
    Store.init().then(() => {
        if (props.preselectedpaymentmethod.length) {
            Store.setPaymentMethod(props.preselectedpaymentmethod)
        }
        if (!multiplePaymentsEnabled.value) {
            Store.setPaymentMethod(firstEnabledPaymentMethod.value)
        }
    })
})

const firstEnabledPaymentMethod = computed(() => {
    switch (true) {
        case vippsEnabled.value:
            return 'vipps'
        case nettbankEnabled.value:
            return 'nettbank'
    }
    return null
})

const isLoading = computed(() => Store.getLoading())
const selectedVipps = computed(() => Store.getPaymentMethod() === 'vipps')
const selectedNettbank = computed(() => Store.getPaymentMethod() === 'nettbank')
const paymentMethodIsSet = computed(() => Store.getPaymentMethod() !== null)
const shouldFadeOut = computed(() => false)
const vippsEnabled = computed(() => Store.getPaymentMethods().vipps && window.hasModule('VIPPS'))
const nettbankEnabled = computed(() => Store.getPaymentMethods().nettbank)
const displayPaymentMethods = computed(() => Store.getDisplayPaymentMethods())
const errorMessage = computed(() => Store.getErrorMessage())
const successMessage = computed(() => Store.getSuccessMessage())
const isOptima = computed(() => Store.state.optima)
const isLocalEnvironment = computed(() => Store.isLocalEnvironment())
const multiplePaymentsEnabled = computed(() => {
    let enabled = 0
    if (vippsEnabled.value) {
        enabled++
    }
    if (nettbankEnabled.value) {
        enabled++
    }
    return enabled > 1
})

const selectPaymentMethod = (method) => {
    Store.setPaymentMethod(method)
}
</script>
